import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
    {
        path: '/',
        redirect: '/main'
    },
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
        meta: {
            title: '自述文件'
        },
        children: [{
            path: '/main',
            name: 'main',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/Index.vue'),
            meta: {
                title: '首页'
            }
        },
        {
            path: '/order',
            name: 'order',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order/Order.vue'),
            meta: {
                title: '我的订单'
            }
        },
        {
            path: '/myCourses',
            name: 'myCourses',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/course/MyCourses.vue'),
            meta: {
                title: '我的课程'
            }
        },
		{
		    path: '/myDetailed',
		    name: 'myDetailed',
		    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Detailed/myDetailed.vue'),
		    meta: {
		        title: '我的清单'
		    }
		},
        {
            path: '/submitCourseReport',
            name: 'myCourses',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/course/SubmitCourseReport.vue'),
            meta: {
                title: '提交报告'
            }
        },
        {
            path: '/report',
            name: 'report',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/report/Report.vue'),
            meta: {
                title: '我的报告'
            }
        },
		{
		    path: '/studentEvaluation',
		    name: 'studentEvaluation',
		    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/studentEvaluation/studentEvaluation.vue'),
		    meta: {
		        title: '老师评分'
		    }
		},
		{
		    path: '/studentList',
		    name: 'studentList',
		    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/studentEvaluation/studentList.vue'),
		    meta: {
		        title: '老师评分'
		    }
		},
        {
            path: '/courseDetail',
            name: 'courseDetail',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/CourseDetail.vue'),
            meta: {
                title: '课程详情'
            }
        },
		{
		    path: '/courseDetailed',
		    name: 'myDetailed',
		    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Detailed/CourseDetailed.vue'),
		    meta: {
		        title: '课程详情'
		    }
		},
        {
            path: '/downloadGuide',
            name: 'main',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/DownloadGuide.vue'),
            meta: {
                title: '操作指南'
            }
        },
        {
            path: '/faq',
            name: 'main',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/FAQ.vue'),
            meta: {
                title: '热门问题'
            }
        },
        {
            path: '/orderDetail',
            name: 'main',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/OrderDetail.vue'),
            meta: {
                title: '订单详情'
            }
        },
		{
		    path: '/OrderDetailed',
		    name: 'myDetailed',
		    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Detailed/OrderDetailed.vue'),
		    meta: {
		        title: '清单订单详情'
		    }
		},
        {
            path: '/pay',
            name: 'main',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/Pay.vue'),
            meta: {
                title: '订单付款'
            }
        },
        {
            path: '/submitReport',
            name: 'report',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/report/SubmitReport.vue'),
            meta: {
                title: '提交报告'
            }
        },
		{
		    path: '/videoupload',
		    name: 'videoupload',
		    component: () => import(/* webpackChunkName: "dashboard" */ '../components/common/videoupload.vue'),
		    meta: {
		        title: '视频上传'
		    }
		},
        {
            path: '/user',
            name: 'user',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/User.vue'),
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/editUser',
            name: 'user',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/EditUser.vue'),
            meta: {
                title: '编辑个人信息'
            }
        },
        {
            path: '/myNote',
            name: 'user',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/MyNote.vue'),
            meta: {
                title: '我的通知'
            }
        },
		{
		    path: '/MyWallet',
		    name: 'user',
		    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/MyWallet.vue'),
		    meta: {
		        title: '我的钱包'
		    }
		},
        {
            path: '/myCollect',
            name: 'user',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/MyCollect.vue'),
            meta: {
                title: '我的收藏'
            }
        },
        {
            path: '/viewNote',
            name: 'user',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/ViewNote.vue'),
            meta: {
                title: '通知详情'
            }
        },
        {
            path: '/usageclauses',
            name: 'user',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/Usageclauses.vue'),
            meta: {
                title: '软件使用条款'
            }
        },
        {
            path: '/404',
            component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
            meta: {
                title: '404'
            }
        },
        {
            path: '/403',
            component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
            meta: {
                title: '403'
            }
        }
        ]
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
        meta: {
            title: '登录',
            isLogin: true
        }
    },
    {
        path: '/password',
        component: () => import(/* webpackChunkName: "login" */ '../components/page/Password.vue'),
        meta: {
            title: '忘记密码'
        }
    },
    // {
    //     path: '/updatePassword',
    //     component: () => import(/* webpackChunkName: "login" */ '../components/page/UpdatePassword.vue'),
    //     meta: {
    //         title: '更新密码'
    //     }
    // },
	{
	    path: '/videoClass',
	    component: () => import(/* webpackChunkName: "login" */ '../components/page/videoClass.vue'),
	    meta: {
	        title: '视频课程'
	    }
	},
	{
	    path:'/czsc',
	    component: () => import(/* webpackChunkName: "login" */ '../components/page/czsc.vue'),
		meta: {
		    title: '操作指南',
			isLogin: true
		}
	},
    {
        path: '*',
        redirect: '/404'
    }
	
	
	
]

// export default new Router({
//     routes: [{
//         path: '/',
//         redirect: '/main'
//     },
//     {
//         path: '/',
//         component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
//         meta: {
//             title: '自述文件'
//         },
//         children: [{
//             path: '/main',
//             name: 'main',
//             component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/Index.vue'),
//             meta: {
//                 title: '首页'
//             }
//         },
//         {
//             path: '/order',
//             name: 'order',
//             component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order/Order.vue'),
//             meta: {
//                 title: '我的订单'
//             }
//         },
//         {
//             path: '/myCourses',
//             name: 'myCourses',
//             component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/course/MyCourses.vue'),
//             meta: {
//                 title: '我的课程'
//             }
//         },
//         {
//             path: '/submitCourseReport',
//             name: 'myCourses',
//             component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/course/SubmitCourseReport.vue'),
//             meta: {
//                 title: '提交报告'
//             }
//         },
//         {
//             path: '/report',
//             name: 'report',
//             component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/report/Report.vue'),
//             meta: {
//                 title: '我的报告'
//             }
//         },
//         {
//             path: '/courseDetail',
//             name: 'main',
//             component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/main/CourseDetail.vue'),
//             meta: {
//                 title: '课程详情'
//             }
//         },
//         {
//             path: '/submitReport',
//             name: 'report',
//             component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/report/SubmitReport.vue'),
//             meta: {
//                 title: '提交报告'
//             }
//         },
//         {
//             path: '/404',
//             component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
//             meta: {
//                 title: '404'
//             }
//         },
//         {
//             path: '/403',
//             component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
//             meta: {
//                 title: '403'
//             }
//         }
//         ]
//     },
//     {
//         path: '/login',
//         component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
//         meta: {
//             title: '登录'
//         }
//     },
//     {
//         path: '*',
//         redirect: '/404'
//     }
//     ]
// })

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js